import { CaDialogComponent } from '../ca-dialog.base'
import { Component, Inject, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable, Subscription } from 'rxjs'
import { selectActionProgressDialogFeature } from './state/action-progress-dialog.selectors'

@Component({
    selector: 'ca-action-progress-dialog',
    templateUrl: './action-progress-dialog.html',
})
export class ActionProgressDialogComponent extends CaDialogComponent<void, boolean> implements OnDestroy {

    show: boolean
    text: string

    actionProgressDialogFeature$: Observable<any>
    #actionProgressDialogFeature: Subscription

    constructor(@Inject(Store) protected store: Store,
    ) {
        super()
        this.actionProgressDialogFeature$ = this.store.select(selectActionProgressDialogFeature)
        this.#actionProgressDialogFeature = this.actionProgressDialogFeature$.subscribe(feature => {
            // Zavřít jen při přechodu zobrazeno -> skryto. CDK Dialog vytváří komponentu
            // synchronně v dialog.open() (na rozdíl od ngx-simple-modal), takže konstruktor
            // se subscribne dřív, než effect dispatchne setShow(true) → první emise nese
            // show=false. `feature.show !== this.show` (this.show=undefined) by to vyhodnotil
            // jako přechod a dialog by se hned zavřel. `this.show === true` to ošetří.
            if (feature.show === false && this.show === true) {
                super.result = false
                super.close()
            }

            this.show = feature.show
            this.text = feature.text
        })

    }

    ngOnDestroy() {
        this.#actionProgressDialogFeature?.unsubscribe()
    }
}
